import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Card } from '@/components/ui/Surface/Card';
export const CardSliderItem = (props) => {
    const { children, className = '', isBorder = true, isRounded = true, isShadow = false, } = props;
    return (_jsx("div", Object.assign({ className: clsx('w-full px-8', className) }, { children: _jsx(Card, Object.assign({ className: clsx('w-full', isBorder && 'border border-solid border-dark'), isRounded: isRounded, isShadow: isShadow }, { children: children })) })));
};
